import {
    emptyValidator,
    dateMustBeGreaterThanTodayNMValidator,
    greaterThanZeroValidator,
  numberOnlyValidator
  } from "../../validators";
  
  const issueValidationStatus = {
    topic: {
      validators: [emptyValidator()],
      name: "Topic",
    },
  
    vehicleId: {
      validators: [emptyValidator()],
      name: "Vehicle",
    },
  
    description: {
      validators: [emptyValidator()],
      name: "Description",
    },
  
    priority: {
      validators: [emptyValidator()],
      name: "Priority",
    },
  
    reportDateTime: {
      validators: [emptyValidator()],
      name: "Report Date & Time",
    },
  
    dueDate: {
      validators: [
        emptyValidator(),
        dateMustBeGreaterThanTodayNMValidator(),
      ],
      name: "Due Date",
    },
  
    status: {
      validators: [emptyValidator()],
      name: "Status",
    },
    primaryMeter: {
        validators: [
          numberOnlyValidator(),
          greaterThanZeroValidator()
        ],
        name: "Primary Meter",
      },
      primaryMeterDue: {
        validators: [
          numberOnlyValidator(),
          greaterThanZeroValidator()
        ],
        name: "Primary Meter Due",
      },
  };
  
  export const issueValidation = (data) => {
    const { formValidator } = require("../../validators");
    return formValidator(data, issueValidationStatus);
  };

  